<div class="container">
    <div class="row">
        <article
            *ngFor="let content of data.content"
            class="col-12 col-md-6 col-xl-4"
            [ngClass]="[
                data.alignment === alignment.Right && data.content.length === 1 ? 'offset-md-6' : 'offset-xl-1'
            ]"
        >
            <app-spot-headline *ngIf="content.headlineText" [index]="data.spotIndex">
                {{ content.headlineText }}
            </app-spot-headline>

            <div
                *ngIf="content.richText"
                class="kk-rte"
                appInterceptLinks
                [innerHTML]="content.richText | safe: 'html'"
            ></div>
        </article>
    </div>
</div>
